import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDialogType, Personality, REGEX } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { City } from 'src/app/models/city';
import { Colony } from 'src/app/models/colony';
import { Customer } from 'src/app/models/customer';
import { Ip800 } from 'src/app/models/ip800';
import { Region } from 'src/app/models/region';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { CityService } from 'src/app/services/city.service';
import { ColonyService } from 'src/app/services/colony.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Ip800Service } from 'src/app/services/ip800.service';
import { ParamsService } from 'src/app/services/params.service';
import { RegionService } from 'src/app/services/region.service';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-pos-ip800-modal',
  templateUrl: './pos-ip800-modal.component.html',
  styleUrls: ['./pos-ip800-modal.component.sass']
})
export class PosIp800ModalComponent {
  @Input()
  customer: CustomerTableModel = new CustomerTableModel();
  @Output()
  confirmActionEmitter: EventEmitter<Blob> = new EventEmitter<Blob>();
  private confirmAction: (value: Blob) => any = (value: Blob) => { };
  regions: Array<Region> = new Array<Region>();
  cities: Array<City> = new Array<City>();
  colonies: Array<Colony> = new Array<Colony>();

  region: Region = new Region();
  city: City = new City();
  colony: Colony = new Colony();

  ip800Form: FormGroup = this.formBuilder.group({
    name: new FormControl(),
    region: new FormControl("", Validators.required),
    city: new FormControl("", Validators.required),
    colony: new FormControl("", Validators.required),
    streetOrAvenue: new FormControl("", Validators.required),
    blockNumber: new FormControl(),
    houseNumber: new FormControl("", Validators.required),
    cellPhone: new FormControl("", [Validators.required]),
    otherPhone: new FormControl(""),
    email: new FormControl("", Validators.pattern(REGEX.email)),
    commercialRegistry: new FormControl(""),
    seatFolioVolumeRegistration: new FormControl("")
  });

  phoneMask: string = "";
  @Input()
  ip800: Ip800 = new Ip800();
  constructor(public bsModalRef: BsModalRef, private readonly formBuilder: FormBuilder, private readonly regionService: RegionService, private readonly cityService: CityService, private readonly colonyService: ColonyService, private readonly paramsService: ParamsService, private readonly ip800Service: Ip800Service, private readonly confirmService: PosConfirmationService, private readonly reportService: ReportService, private readonly customerService: CustomerService) {

  }

  async load() {
    this.ip800 = (await this.ip800Service.readIP800Requests(this.customer.code).toPromise()).response.content[0] || new Ip800();

    if (this.customer.code && this.ip800.code) {
      this.confirmService.show("Solicitud IP800", "Ya existe una solicitud IP800, ¿Desea imprimirlo en su lugar?", ModalDialogType.SUCCESS, () => {
        this.confirm(this.ip800.code);
      }, async () => {
        await this.loadForms();
      })
    }
    else {
      await this.loadForms();
    }
  }

  async loadForms() {
    await this.getRegion();
    this.ip800Form.get("name")?.disable();
    this.phoneMask = "+(000) 0000-0000";
    const customer = new Customer();
    const customerFromServer = await this.customerService.readCustomerByCode(this.customer.code).toPromise();
    Object.assign(customer.mainPersonalInfo, customerFromServer.mainPersonalInfo);
    this.ip800Form.get("name")?.setValue(this.customer.fullName);
    this.ip800Form.get("region")?.setValue(this.regions.find(f => f.region == customer.mainPersonalInfo.getHomeAddress().department));
    this.ip800Form.get("city")?.setValue(customer.mainPersonalInfo.getHomeAddress().city);
    this.ip800Form.get("colony")?.setValue(customer.mainPersonalInfo.getHomeAddress().state);
    this.ip800Form.get("streetOrAvenue")?.setValue(customer.mainPersonalInfo.getHomeAddress().street);
    this.ip800Form.get("blockNumber")?.setValue(customer.mainPersonalInfo.getHomeAddress().block);
    this.ip800Form.get("houseNumber")?.setValue(customer.mainPersonalInfo.getHomeAddress().houseNumber);
    this.ip800Form.get("cellPhone")?.setValue(`+(${customer.mainPersonalInfo.getFirstMobilePhone().countryCode}) ${customer.mainPersonalInfo.getFirstMobilePhone().phoneNumber}`);
    this.ip800Form.get("otherPhone")?.setValue(`+(${customer.mainPersonalInfo.getFirstMobilePhone().countryCode}) `);

    this.ip800Form.get("email")?.setValue(customer.mainPersonalInfo.email);


  }

  async getRegion() {
    //TODO: Customer Nationality filter
    this.regions = (await this.regionService.readRegions("HN").toPromise()).response.content;
    this.regions = this.regions.sort((a, b) => a.name.localeCompare(b.name));

    this.cities = new Array<City>();
    this.colonies = new Array<Colony>();
  }

  async changeRegion(region: Region) {
    await this.getCities(region.country, region.region);
  }

  async getCities(countrySelected: string, regionSelected: string) {
    this.colonies = new Array<Colony>();
    this.cities = (await this.cityService.readCities(countrySelected, regionSelected).toPromise()).response.content;
    this.cities = this.cities.sort((a, b) => a.name.localeCompare(b.name));
  }

  async changeCity(region: City) {
    await this.getColonies(region.cityCode);
  }

  async getColonies(citySelected: string) {
    this.colonies = (await this.colonyService.readColonies(citySelected).toPromise()).response.content;
  }

  async createIp800() {
    let result = new Ip800();

    result.customerCode = this.customer.code;
    result.creationDate = new Date();
    result.city = (this.ip800Form.get("region")?.value as Region).name;
    result.department = (this.ip800Form.get("region")?.value as Region).name;
    result.municipality = (this.ip800Form.get("city")?.value as City).name;
    result.neighbourhoodColonyOrvillage = (this.ip800Form.get("colony")?.value as Colony).name;
    result.streetOrAvenue = this.ip800Form.get("streetOrAvenue")?.value;
    result.blockNumber = this.ip800Form.get("blockNumber")?.value;
    result.houseNumber = this.ip800Form.get("houseNumber")?.value;
    result.cellularPhone = this.ip800Form.get("cellPhone")?.value;
    result.otherPhone = this.ip800Form.get("otherPhone")?.value;
    result.emailAddress = this.ip800Form.get("email")?.value;
    result.seatFolioVolumeRegistration = this.ip800Form.get("seatFolioVolumeRegistration")?.value;
    result.commercialRegistry = this.ip800Form.get("commercialRegistry")?.value;


    if (!this.ip800.code) {
      result = (await this.ip800Service.createIP800(result).toPromise()).response;
    }
    else {
      result.code = this.ip800.code;
      await this.ip800Service.updateIP800(result).toPromise();
    }

    this.confirm(result.code);
  }

  async confirm(code: string) {
    let pdf = await this.reportService.ip800RequestPdf(code).toPromise();
    this.confirmAction(pdf);
    this.confirmActionEmitter.emit(pdf);
    this.confirmActionEmitter.complete();
    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide()
  }

  get isLegalEntity() {
    return this.customer.personality == Personality.LEGAL_ENTITY;
  }
}
